<template>
    <div>
        <b-modal
            id="labConnectionError"
            ref="labConnectionError"
            :lazy="true"
            :no-close-on-esc="true"
            :no-close-on-backdrop="true"
            title="Error"
            title-tag="h2"
        >
            <!-- Modal Form -->
            <div>
                We are currently unable to connect to
                {{ errorSource.join(", ") }}. Our support team has been notified
                and is investigating the issue. We will notify you when the
                error is resolved. We apologize for the inconvenience.
            </div>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.labConnectionError.hide()"
                    class="float-left"
                    variant="secondary"
                    >Close</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "labConnectionError",
    components: {},
    data() {
        return {
            errorSource: []
        };
    },
    computed: {},
    mounted() {},
    methods: {
        open(response) {
            let self = this;
            let sources = response.lab_connection_error;

            if (sources.length > 0) {
                _.forEach(sources, function (source) {
                    switch (source) {
                        case "ANTECH":
                        case "ANTECH_WEST":
                        case "ANTECH_EAST":
                            self.errorSource.push("Antech");
                            break;
                        case "ZNLABS":
                            self.errorSource.push("Zoetis");
                            break;
                        case "MIDWEST":
                            self.errorSource.push(
                                "Midwest Veterinary Laboratory"
                            );
                            break;
                        case "NBIOVET":
                            self.errorSource.push("National Biovet");
                            break;
                        case "IDEXX":
                            self.errorSource.push("IDEXX");
                            break;
                        case "VETEK":
                            self.errorSource.push("Vetek");
                            break;
                        case "MICROVET":
                            self.errorSource.push("Microvet");
                            break;
                        case "BIONOTE":
                            self.errorSource.push("Bionote");
                            break;
                    }
                });
            }
            self.$refs["labConnectionError"].show();
        }
    }
};
</script>
